import React, {useMemo} from "react";
import {useSelector} from "react-redux";
import {RootStore} from "../../../../../configureStore";
import {WithTitleField} from "../../Styled";
import FieldWrapper from "../../FieldWrapper";
import ExamScoreField from "./ExamScoreField";

const ExamScore: React.FC = () => {
    const level = useSelector((state: RootStore) => state.RegistrationLoginPage.level);
    const bachelorFieldsExamScore = useSelector(
        (state: RootStore) => state.RegistrationLoginPage.bachelorFields?.examScore,
    );
    const masterFieldsExamScore = useSelector(
        (state: RootStore) => state.RegistrationLoginPage.masterFields?.examScore,
    );
    const phdFieldsExamScore = useSelector(
        (state: RootStore) => state.RegistrationLoginPage.phdFields?.examScore,
    );

    const examScore = level
        ? level === "Bachelors"
            ? bachelorFieldsExamScore
            : level === "Masters"
            ? masterFieldsExamScore
            : phdFieldsExamScore
        : undefined;

    return useMemo(() => {
        if (examScore) {
            const {visible, loading, values, fieldName, selectedValue, editable} = examScore;

            return (
                <FieldWrapper
                    visible={visible}
                    loading={loading}
                    loaderType="Exam Loader"
                    fullWidthDiv={true}
                >
                    <>
                        {values && (
                            <WithTitleField>
                                <h4>Select & Enter your exam score</h4>
                                {values.map((examScoreValue, index) => {
                                    return (
                                        <ExamScoreField
                                            key={`examScore_${examScoreValue.id}`}
                                            examScoreValue={examScoreValue}
                                            editable={editable}
                                            fieldName={fieldName}
                                            index={index}
                                            selectedValue={selectedValue}
                                        />
                                    );
                                })}
                            </WithTitleField>
                        )}
                    </>
                </FieldWrapper>
            );
        }
        return null;
    }, [examScore]);
};

export default ExamScore;
